import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import es from './locales/es.json'
import pap from './locales/pap.json'
import nl from './locales/nl.json'
import { SUPPORTED_LOCALES } from '../lib/constants'

function updateDocumentLanguage(language?: string) {
  if (typeof document === 'undefined') return
  const base = language?.toLowerCase().split('-')[0]
  document.documentElement.lang = SUPPORTED_LOCALES.includes(
    base as (typeof SUPPORTED_LOCALES)[number],
  )
    ? base!
    : 'en'
}

i18n.on('languageChanged', updateDocumentLanguage)

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pap: { translation: pap },
      nl: { translation: nl },
    },
    supportedLngs: [...SUPPORTED_LOCALES],
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    detection: {
      // Prefer device/browser language among en / es / pap / nl
      order: ['navigator', 'htmlTag', 'localStorage', 'querystring'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      convertDetectedLanguage: (lng: string) => {
        const base = lng.toLowerCase().split('-')[0]
        // Papiamento sometimes reported as pap, pap-AW, or rarely as 'papiamento'
        if (base === 'papiamento' || base === 'pap') return 'pap'
        if (base === 'es' || base.startsWith('es')) return 'es'
        if (base === 'nl' || base.startsWith('nl')) return 'nl'
        if (base === 'en' || base.startsWith('en')) return 'en'
        return 'en'
      },
    },
    interpolation: { escapeValue: false },
  })
  .then(() => updateDocumentLanguage(i18n.resolvedLanguage))

export default i18n
